import './scss/app';

import LayoutLoader from './js/loaders/layout';
import EnvironmentLoader from './js/loaders/environment';

new LayoutLoader([{
    selector : `[href^="${theme_vars.resources.base}"]`,
    import : () => import('./js/layouts/resources')
}]);

new EnvironmentLoader([{
	selector : `body.theme-frontend`,
	import : () => import('./js/environments/frontend')
},{
	selector : `body.resource-embedded`,
	import : () => import('./js/environments/resource-iframe')
}]);